import 'twin.macro';
import React from 'react';
import { NotationSystem } from 'types/notationSystem';
import { useTranslation } from 'react-i18next';
import Dialog from 'components/Dialog';
import { LivretEleve } from 'containers/Livrets/types/livret';
import { SyncLivretModalBody } from './SyncLivretModalBody';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  notationSystem: NotationSystem;
  livretEvalId: string;
  livretEleve: LivretEleve;
}

export function SyncLivretModal({
  isOpen,
  onClose,
  livretEleve,
  livretEvalId,
  notationSystem,
}: Props) {
  const { t } = useTranslation(['carnet', 'common']);

  return (
    <Dialog
      size="xl"
      isOpen={isOpen}
      onClose={onClose}
      title={t('carnet:syncLivret.modal.title')}
    >
      <SyncLivretModalBody
        notationSystem={notationSystem}
        livretEleve={livretEleve}
        livretEvalId={livretEvalId}
        onClose={onClose}
      />
    </Dialog>
  );
}
